export interface ChatPanelSlashCommand {
  name: string;
  description: string;
  usage: string;
}

export interface ChatPanelSlashSuggestion {
  command: string;
  description: string;
  usage: string;
}

export function listChatPanelSlashSuggestions(
  draft: string,
  commands: ChatPanelSlashCommand[]
): ChatPanelSlashSuggestion[] {
  if (!draft.startsWith('/')) return [];
  const part = draft.slice(1).split(/\s/)[0]?.toLowerCase() ?? '';
  const matched = commands.filter((cmd) => {
    if (!part) return true;
    const name = cmd.name.toLowerCase();
    return name.startsWith(part) || name.includes(part);
  });
  const limit = part ? 5 : 10;
  return matched.slice(0, limit).map((cmd) => ({
    command: cmd.name,
    description: cmd.description,
    usage: cmd.usage,
  }));
}
